import module from 'empresa/module.js'
import template from './template.html'

export class EmpresaReportesPldComponent {
  empresaId = undefined
  data = {periodo: null}

  $onInit () {
    let hoy = new Date()
    this.data.fecha = new Date(hoy.getFullYear(), hoy.getMonth(), 1)
    this.maximo = new Date(hoy.getFullYear(), hoy.getMonth())
  }
}

module.component('empresaReportesPld', {
  controller: EmpresaReportesPldComponent,
  template,
  bindings: {
    empresaId: '<',
  },
})



// WEBPACK FOOTER //
// ./src/empresa/components/reportes/pld/component.js